module.exports = __webpack_public_path__ + "static/media/opening-times_1.d565d7fe.svg";